import { render, staticRenderFns } from "./DocumentRequest.vue?vue&type=template&id=7a97b7c4"
import script from "./DocumentRequest.vue?vue&type=script&lang=js"
export * from "./DocumentRequest.vue?vue&type=script&lang=js"
import style0 from "./DocumentRequest.vue?vue&type=style&index=0&id=7a97b7c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports